import { getApiErrorMessage } from './apiErrorMessage';

const normalizeClientId = (value) => {
  const candidate = value && typeof value === 'object' ? value.id : value;
  if (typeof candidate === 'number') {
    return Number.isInteger(candidate) && candidate > 0 ? candidate : null;
  }
  if (typeof candidate === 'string' && /^\d+$/.test(candidate.trim())) {
    const parsed = Number(candidate.trim());
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
  }
  return null;
};

export const normalizeClientIds = (clientes) => {
  if (!Array.isArray(clientes)) return [];
  const seen = new Set();
  return clientes.reduce((ids, cliente) => {
    const id = normalizeClientId(cliente);
    if (id !== null && !seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
    return ids;
  }, []);
};

export const normalizeVehicleForList = (vehicle) => ({
  ...vehicle,
  clientes: normalizeClientIds(vehicle?.clientes),
});

export const splitCombinedPlate = (value) => {
  const [plateT = '', plateABC = ''] = String(value || '').split('-', 2);
  return { plateT, plateABC };
};

export const combinePlates = ({ plateT, plateABC }) => (
  plateT && plateABC ? `${plateT}-${plateABC}`.toUpperCase() : ''
);

export const getVehicleEditErrorMessage = (error) => getApiErrorMessage(
  error,
  'No fue posible actualizar el vehículo.',
  ['placa', 'cliente_ids']
);
